import { useTranslation } from 'react-i18next';

/**
 * Custom hook for i18n translations with default namespace
 * @param {string} namespace - Optional namespace, defaults to 'common'
 * @returns {object} - Object containing t function and other i18next utilities
 */
export const useI18n = (namespace = 'common') => {
  const { t, i18n, ready } = useTranslation(namespace);

  /**
   * Translation function with default namespace
   * @param {string} key - Translation key
   * @param {object} options - Translation options (interpolation, etc.)
   * @returns {string} - Translated string
   */
  const translate = (key, options = {}) => {
    return t(key, options);
  };

  /**
   * Get current language
   * @returns {string} - Current language code
   */
  const getCurrentLanguage = () => {
    return i18n.language;
  };

  /**
   * Check if current language is RTL
   * @returns {boolean} - True if RTL language
   */
  const isRTL = () => {
    return i18n.dir() === 'rtl';
  };

  return {
    t: translate,
    i18n,
    ready,
    getCurrentLanguage,
    isRTL,
    currentLanguage: i18n.language,
  };
};

export default useI18n;
